var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.categories)?_c('div',{staticClass:"w-full"},[(_vm.desktop)?_c('tree-menu-desktop',{attrs:{"categories":_vm.categories}}):_c('tree-menu-mobile',{attrs:{"categories":_vm.categories}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }